import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { ProposalDetail } from '~/components/funnel/proposal-detail'
import { titleFor } from '~/lib/route-title'
import type { Id } from '~convex/_generated/dataModel'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/documents/$documentId')({
  component: DocumentDetailRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Proposal`) }] }),
})

function DocumentDetailRoute() {
  const { documentId } = Route.useParams()
  return <ProposalDetail id={documentId as Id<'documents'>} />
}
